// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_fa","advertDetailContactGroup__header":"c-n_fb","advertDetailContactGroup__value":"c-n_fc"};